import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchTopCompanies } from "./TopCompaniesAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchTopCompaniesAsync = createAsyncThunk(
  "TopCompanies/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchTopCompanies();

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TopCompaniesSlice = createSlice({
  name: "TopCompanies",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopCompaniesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTopCompaniesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchTopCompaniesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectTopCompanies = (state) => state.topCompanies.data;

export default TopCompaniesSlice.reducer;
